import { Anchor, Box, Text } from '@mantine/core';
import { Link } from 'react-router-dom';
import { EMAIL_SUPORT } from '../constante';

// acelasi albastru inchis ca bara de sus a aplicatiei
const ALBASTRU_INCHIS = 'rgb(4, 36, 66)';

// subsolul din toate paginile: intai intrebarile frecvente, apoi mail-ul de suport
function SubsolSuport({ isProfessor }) {
  const linkIntrebari = (
    <Anchor component={Link} to="/faq" size="13px" fw={700} style={{ color: ALBASTRU_INCHIS}}>
      Întrebări frecvente
    </Anchor>
  );
  const linkMail = <Anchor href={`mailto:${EMAIL_SUPORT}`} size="13px">{EMAIL_SUPORT}</Anchor>;

  return (
    <Box bg="white" p="sm" m="0 20px 30px" style={{ borderRadius: 4, textAlign: 'center' }}>
      <Text size="13px">
        {isProfessor ? (
          <>Aveți o întrebare? Căutați mai întâi răspunsul în secțiunea {linkIntrebari}. Dacă nu îl găsiți
            acolo, ne puteți scrie un mail cu detalii la {linkMail}.</>
        ) : (
          <>Ai o întrebare? Caută mai întâi răspunsul în secțiunea {linkIntrebari}. Dacă nu îl găsești
            acolo, scrie-ne un mail cu detalii la {linkMail}.</>
        )}
      </Text>
    </Box>
  );
}

export default SubsolSuport;
